import { VALIDATION_STATE } from "../hooks/useValidation";
import { SpanishTin } from "../utils/TinParsers/SpanishTin";
import { BaseValidator } from "./BaseValidator";
export class SpanishTinValidator extends BaseValidator {
    constructor() {
        super(...arguments);
        this.name = "SpanishTinValidator";
    }
    getId() {
        return this.getBaseId();
    }
    validate(value) {
        if (value.length === 0) {
            return Promise.resolve({
                status: VALIDATION_STATE.SUCCESS,
                hideError: true,
            });
        }
        return new Promise((resolve) => {
            const tin = new SpanishTin(value);
            if (!tin.isValid()) {
                resolve({
                    status: VALIDATION_STATE.FAILED,
                    message: this.error,
                    hideError: value.length < 11,
                });
            }
            else {
                resolve({ status: VALIDATION_STATE.SUCCESS });
            }
        });
    }
}
